export default {"src":"/_next/static/media/user.9a7612d1.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};